import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
  Flex,
} from '@bridebook/aura';
import { Box } from '@bridebook/ui';
import { IconSearchHeart } from '@bridebook/ui/src/icons/dynamic';
import { RsvpText } from '@bridebook/web/components/wedding-website/rsvp/rsvp-list/partials/rsvp-text';
import { RsvpTitle } from '@bridebook/web/components/wedding-website/rsvp/rsvp-list/partials/rsvp-title';
import { PillList } from '@bridebook/web/components/wedding-website/rsvp/question-form/partials/pill-list';
import { RsvpQuestion } from '@bridebook/web/lib/rsvp/types';
import { useTranslation } from 'next-i18next';

interface IProps {
  currentQuestion: RsvpQuestion;
  onAdd: (q: RsvpQuestion) => void;
}

export const PopularQuestions = ({ currentQuestion, onAdd }: IProps) => {
  const { t } = useTranslation('weddingWebsite');
  return (
    <Accordion
      type="single"
      defaultValue=""
      collapsible
      className="rounded-xl border-1 border-space-40">
      <AccordionItem value="popular-questions" className="border-b-0">
        <AccordionTrigger>
          <Box flexDirection="row" gap={4} pr={4}>
            <IconSearchHeart width={24} />
            <Flex className="flex-col">
              <RsvpTitle>{t('rsvp.form.title')}</RsvpTitle>
              <RsvpText>{t('rsvp.form.subtitle')}</RsvpText>
            </Flex>
          </Box>
        </AccordionTrigger>
        <AccordionContent>
          <Flex className="flex-row flex-wrap gap-2">
            <PillList onAdd={onAdd} currentQuestion={currentQuestion} />
          </Flex>
        </AccordionContent>
      </AccordionItem>
    </Accordion>
  );
};
